const arrayToObject = (array, val) =>
  array.reduce((obj, item) => {
    obj[item[val]] = item;
    return obj;
  }, {});

export default arrayToObject;
